<template>
    <div class="modify-pwd-component">
        <el-form ref="modelForm" :model="modelForm" label-width="90px" size="small" :rules="modelFormRules">
            
            <el-form-item label="原密码" prop="oldPassword">
                <el-input type="password" v-model="modelForm.oldPassword" placeholder="请输入原密码" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
                <el-input type="password" v-model="modelForm.password" placeholder="请输入至少8位密码,且字母、数字和符号至少包含两种" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="rePassword">
                <el-input type="password" v-model="modelForm.rePassword" placeholder="请输入确认密码" style="width: 250px"></el-input>
            </el-form-item>
        </el-form>

        <div class="footer" style="margin:0 20px;text-align:center;">
            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            <el-button type="text" @click="handleResetForm">清空</el-button>

        </div>
    </div>
</template>


<script>
export default {
   
    data() {
        const validatePassWord = (rule, value, callback) => {
            // let reg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
            let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,}$/;
            if (!reg.test(value)) {
                callback(new Error("请输入至少8位密码,且字母、数字和符号至少包含两种"));
            } else {
                callback();
            }
        };

        const validerePasswordword = (rule, value, callback) => {
            if (value !== this.modelForm.password) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };
        return {
            modelFormRules: {
                oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
                password: [{ trigger: "blur", validator: validatePassWord, required: true }],
                rePassword: [
                    { required: true, message: "请再次输入新密码", trigger: "blur" },
                    { validator: validerePasswordword, trigger: "blur" }
                ],
            },
            modelForm: {
                password: '',
                oldPassword: '',
                rePassword: ""
            },
            submitLoading: false
        }
    },
    methods: {
        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest('/api/user/modifyPassword', this.modelForm)
                        .then(res => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success('修改成功');
                                this.modelForm = {
                                    password: '',
                                    oldPassword: '',
                                    rePassword: ""
                                }
                            }
                        }).catch(() => {
                            this.submitLoading = false;
                        })
                }
            })
        },
        handleResetForm() {
            this.modelForm = {
                password: '',
                oldPassword: '',
                rePassword: ""
            }
        }
        
    },
}
</script>